module.exports = __webpack_public_path__ + "img/cusromerLogo3.656db8e6.png";